import { render, staticRenderFns } from "./CragArticles.vue?vue&type=template&id=edf0fc32"
import script from "./CragArticles.vue?vue&type=script&lang=js"
export * from "./CragArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports